import { render, staticRenderFns } from "./userEdit.vue?vue&type=template&id=1637c330&"
import script from "./userEdit.vue?vue&type=script&lang=js&"
export * from "./userEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports